<template>
  <v-container class="d-flex flex-column pa-0 fill-height" style="min-height:0;" fluid pa-0>
    <FullHeader />
    <BlueprintHeader />
    <ForgeViewer style="flex: 1; min-height: 0; width: 100%;" />
  </v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import BlueprintHeader from './BlueprintHeader'
import ForgeViewer from './ForgeViewer.vue';
export default {
	name: 'Planimetria',
	components: {FullHeader, BlueprintHeader, ForgeViewer},
	computed: {
	},
	watch: {
	},
	data: () => ({
	}),
	mounted(){
	},
	methods:{
	}
};
</script>

<style scoped>
</style>
